import { isAdult } from '@wareclouds/frontend-common';

const LEGAL_AGE_BY_COUNTRY = {
  cl: 18,
  br: 18,
};

function toComparableDateInput(value) {
  if (value == null) return value;
  if (value instanceof Date || typeof value === 'string') return value;
  if (typeof value?.toDate === 'function') return value.toDate();
  return value;
}

export function isAdultByCountry(birthDate, countryCode, today = new Date()) {
  const legalAge = LEGAL_AGE_BY_COUNTRY[(countryCode ?? '').toLowerCase()];

  if (!legalAge) return true;

  return isAdult({
    birthDate: toComparableDateInput(birthDate),
    legalAdultAge: legalAge,
    today: toComparableDateInput(today),
  });
}
